<template>
	<div class="historyDialog">
		<el-dialog
		  :title="data.name"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :modal="false">
			<div id="chathistory">
				<el-menu :default-active="activeName" class="el-menu-demo" mode="horizontal" @select="tabClick">
					<el-menu-item index="allMessage">全部</el-menu-item>
					<el-menu-item index="file">文件</el-menu-item>
					<el-menu-item index="photoAndVideo">图片和视频</el-menu-item>
				</el-menu>
				<div v-if="activeName == 'allMessage'" v-loading="loading" class="scrollBox" @scroll="onScroll" >
					<div v-for="(item,index) in historyList" :key="index" class="contetntbox">
						<img width="40" height="40" :src="item.toUserHead" alt="">
						<div class="historytext">
							<div style="display: flex;justify-content: space-between;font-size:16px">
								<span class="gray">{{item.fromUserName}}</span>
								<span class="gray">{{item.createTime}}</span>
							</div>
							<div style="margin-top:5px" class="historyContent">
								<!-- 文本 -->
								<span v-if="item.chattype == 0" v-html="item.chatcontent"></span>
								<!-- 图片 -->
								<viewer v-else-if="item.chattype == 1" :images="imgArr" style="maxWidth: 300px; maxHeight: 200px">
									<img v-show="showsrc(ig,item)" :src="ig" v-for="(ig,g) in imgArr" :key="g" />
								</viewer>
								<!-- 文件 -->
								<chat-upload v-else-if="item.chattype == 2" ref="uploadFile" :content="JSON.parse(item.chatcontent).msg" :url="JSON.parse(item.chatcontent).fileurl" :isShow="false"></chat-upload>
								<!-- 语音 -->
								<div v-else-if="item.chattype == 3">
									<div style="display: flex;align-items: center;">
										<div style="width: 30%;height: 35px;background-color: #fff;display: flex;" @click="playAudio(item.id,index)">
											<img v-if="isPlay && clickActive == index" style="transform: scale(.5);" :src="require('@/assets/images/sound1.gif')" alt="">
											<img v-else style="transform: scale(.5);" :src="require('@/assets/images/audio.png')" alt="">
										</div>
										<span style="font-size: 14px;margin-left: 10px;">{{Math.ceil(JSON.parse(item.chatcontent).seconds)+"'"}}</span>
									</div>
									<audio :id="'audio'+item.id" controls controlsList="nodownload"  :hidden="true">
										<source :src="JSON.parse(item.chatcontent).audioUrl" >  
									</audio>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="activeName == 'file'" v-loading="loading" class="scrollBox" @scroll="onScroll" >
					<div v-for="(item,index) in historyFileList" :key="index" class="contetntbox">
						<img width="40" height="40" :src="item.toUserHead" alt="">
						<div class="historytext">
							<div style="display: flex;justify-content: space-between;font-size:16px">
								<span class="gray">{{item.fromUserName}}</span>
								<span class="gray">{{item.createTime}}</span>
							</div>
							<div style="margin-top:5px">
								<chat-upload ref="uploadFile" :content="JSON.parse(item.chatcontent).msg" :url="JSON.parse(item.chatcontent).fileurl" :isShow="false"></chat-upload>
							</div>
						</div>
					</div>
				</div>
				<div v-if="activeName == 'photoAndVideo'" v-loading="loading" class="scrollBox" @scroll="onScroll">
					<div v-for="(item,index) in historyList" :key="index" class="contetntbox">
						<img width="40" height="40" :src="item.toUserHead" alt="">
						<div class="historytext">
							<div style="display: flex;justify-content: space-between;font-size:16px">
								<span class="gray">{{item.fromUserName}}</span>
								<span class="gray">{{item.createTime}}</span>
							</div>
							<div style="margin-top:5px" class="historyContent">
								<viewer :images="imgArr" style="maxWidth: 300px; maxHeight: 200px">
									<img v-show="showsrc(ig,item)" :src="ig" v-for="(ig,g) in imgArr" :key="g" />
								</viewer>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import axios from "@/http/axios"
	import chatUpload from "./upload"
	export default {
		props:['data'],
		components:{chatUpload},
		data(){
			return {
				clickActive:null,
				isPlay:false,
				activeName:'allMessage',
				dialogVisible:false,
				historyList:[],
				historyFileList:[],
				loading:false,
				pageSize:10,
				deviceListIsLoad:true,
				totalLength:null,
				srcReg : /src=[\'\"]?([^\'\"]*)[\'\"]?/i,
				imgArr:[],
			}
		},
		watch:{
			totalLength(newVal,oldVal){
				this.deviceListIsLoad = true;
			}
		},
		mounted(){

		},
		methods:{
			showsrc(ig,item){
				if(item.chatcontent.match(this.srcReg) && item.chatcontent.match(this.srcReg).length>0){
					return ig == item.chatcontent.match(this.srcReg)[1]
				}
			},
			// 打开历史记录
			open(){
				this.activeName='allMessage'
				this.loading = true;
				this.dialogVisible = true;
				this.pageSize = 10
				this.getHistory(0)
			},
			// 查找历史记录
			getHistory(type){
				let params = '?page=1&pageSize='+this.pageSize+'&tochatid='+this.data.conversationid+'&fromchatid='+sessionStorage.getItem('chatid')+'&type='+type
				axios({
			    hostUrl: this.zuul,
			    url: '/xyj-im/r/imChatHistory/findChatHistory'+params,
			    method: 'get',
			  }).then((res)=>{
					this.historyList = []
					this.historyFileList = []
					this.imgArr = res.data.rows.filter(item => item.chattype == 1).map(ig => {
						return ig.chatcontent.match(this.srcReg)[1]
					})
					 this.loading = false
					 res.data.rows.forEach((element,i) => {
						 if(type == 2){
							 this.$set(this.historyFileList,i,element)
								// this.historyFileList = res.data.rows;
							}else{	
								this.$set(this.historyList,i,element)
								// this.historyList = res.data.rows;
							}
					 })
					this.totalLength = res.data.rows.length;
					setTimeout(() => {
						// 语音绑定完成事件
						this.historyList.forEach((x,index) => {
							if(x.chattype == 3){
								document.getElementById('audio'+x.id).addEventListener('ended',()=>{
									this.isPlay = false
								})
							}
						})
					})
        }).catch((error)=>{
        	this.loading = false
          this.$message.error(error.message);
        })
			},
			// 滚动事件
			onScroll(e){
				if(e instanceof Event){
					let el = e.target;
					let scrollTop = el.scrollTop;
					let clientHeight = el.clientHeight;
					let scrollHeight = el.scrollHeight;
					if(scrollTop + clientHeight >= scrollHeight && this.deviceListIsLoad){
						this.deviceListIsLoad = false;
						this.pageSize+=10;
						if(this.activeName == 'file'){
							this.getHistory(2)
						}else if(this.activeName == 'photoAndVideo'){
							this.getHistory(1)
						}else if(this.activeName == 'allMessage'){
							this.getHistory(0)
						}
					}
				}
			},
			// 点击标签页
			tabClick(value){
				if(value == 'file'){
					this.activeName = 'file'
					this.getHistory(2)
				}else if(value == 'photoAndVideo'){
					this.activeName = 'photoAndVideo'
					this.getHistory(1)
				}else if(value == 'allMessage'){
					this.activeName = 'allMessage'
					this.getHistory(0)
				}
			},
			search(){

			},
			// 播放语音
			playAudio(id,index){
				this.clickActive = index
				this.isPlay = !this.isPlay
				if(this.isPlay){
					document.getElementById('audio'+id).play()
				}else{
					document.getElementById('audio'+id).pause()
					// document.getElementById('au').load()
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
.scrollBox{
  background-color: #f5f5f5;
	height: 500px;
	overflow-y: auto;
  overflow-x: hidden;
}
	.contetntbox{
		display: flex;
    margin-bottom: 10px;
    box-sizing: border-box;
    // height: 124px;
    padding: 10px;
	}
	.historytext{
		width: 100%;
    border-bottom: 1px solid #ccc;
		box-sizing: border-box;
    padding: 0 0 15px 15px;
	}
	.historyContent{
		font-size: 20px;
	}
	.historyContent /deep/ img{
		max-width: 163px!important;
		max-height: 70px!important;
	}
	.gray{
		color: #ccc;
	}
	.historyDialog{
		.el-dialog__body{
			padding: 0 20px 30px;
		}
	}
	.el-menu-demo{
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/vueChart/history.vue